module.exports = __webpack_public_path__ + "img/checkbox.082b9214.svg";